import {
    Contrast,
    LogoutOutlined,
    MenuOutlined,
    MessageSharp,
    Notifications,
} from "@mui/icons-material";
import { Badge, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ImageController } from "../../Layouts/ImageController";
import { TopNavStyle } from "./TopNavStyle";
import UserImage from "../../Assets/user.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, reset } from "../../Redux/AuthSlice/AuthSlice";
import { toggleSmallSize } from "../../Redux/SwitchSlice";
import { Box } from "@mui/system";
import MessagesBox from "./MessagesBox";
import MessagesCompose from "../../Pages/Messages/MessagesCompose";
import styled from "styled-components";
import {
    GetTheNewMessages,
    messagesCountAdd,
    messagesCountSet,
    messagesReset,
} from "../../Redux/MessagesSlice/MessagesSlice";
import Logo from "../../Assets/logo.png";

//------------------------------------------------------//

//------------------------------------------------------------//
const TopNavbar = ({ switchTheme, MAIN_USER }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { pusher_data } = useSelector((state) => state.pusher);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const PusherData = pusher_data?.data || [];

    // toggle menu in nav
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const { lastChats, messages_count } = useSelector(
        (state) => state.messages
    );
    const Chats = lastChats?.data || [];

    const newChats = Chats?.chats || [];
    // const []
    const chatCount = Chats?.count_chat || 0;

    useEffect(() => {
        const GetTheNewMessageMethod = async () => {
            await dispatch(GetTheNewMessages());
            await dispatch(messagesReset());
        };
        GetTheNewMessageMethod();
    }, [dispatch]);

    const [smallSize, setSmallsize] = useState(true);

    const handelResize = () => {
        if (window.innerWidth <= 1200) {
            setSmallsize(true);
        } else setSmallsize(false);
    };

    useEffect(() => {
        handelResize();
    }, []);

    useEffect(() => {
        if (PusherData) {
            const UpdateTheMessagesCount = async () => {
                await dispatch(messagesCountAdd());
            };
            // UpdateTheMessagesCount();
        }
    }, [PusherData, dispatch]);

    useEffect(() => {
        if (lastChats) {
            dispatch(messagesCountSet(chatCount));
        }
    }, [lastChats, dispatch, chatCount]);

    window.addEventListener("resize", handelResize);

    // =============================
    // ==== Handel Messages Box ====
    // =============================

    const [msgBox, setMsgBox] = useState(false);
    const [composeBox, setComposeBox] = useState(false);
    const openMessagesBox = () => {
        setMsgBox(!msgBox);
    };

    const handelComposeBox = () => {
        setComposeBox(!composeBox);
    };

    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [messages, setMessages] = useState(false);

    useEffect(() => {
        if (path === "messages") {
            setMessages(true);
        } else {
            setMessages(false);
        }
    }, [messages, path]);

    return (
        <>
            <TopNavStyle className="between-flex">
                {/* {!showSearchInput && <Search onClick={() => handelSearchInput()} />}
				{showSearchInput && (
					<TableSearch handelSearchInput={handelSearchInput} />
				)} */}
                <Box>
                    {smallSize && !messages && (
                        <div className="prand center-flex">
                            <IconButton
                                onClick={() => dispatch(toggleSmallSize())}
                            >
                                <MenuOutlined />
                            </IconButton>
                        </div>
                    )}
                    {messages && (
                        <Link to="/">
                            <Prand className=" center-flex">
                                <ImageController
                                    src={Logo}
                                    alt="/"
                                    width="100px"
                                    objectFit="cover"
                                />
                            </Prand>
                        </Link>
                    )}
                </Box>
                {/* <Search /> */}

                <div
                    className="user center-flex"
                    sx={{ justifyContent: "flex-start" }}
                >
                    <IconButton onClick={switchTheme}>
                        <Contrast className="logout" />
                    </IconButton>
                    <IconButton onClick={() => openMessagesBox()}>
                        {chatCount !== 0 && <MessagesCount></MessagesCount>}
                        <MessageSharp />
                    </IconButton>
                    {msgBox && (
                        <MessagesBox
                            close={openMessagesBox}
                            composeBox={handelComposeBox}
                            newChats={newChats}
                        ></MessagesBox>
                    )}
                    <div>
                        <IconButton>
                            <Badge badgeContent={0} color="error">
                                <Notifications />
                            </Badge>
                        </IconButton>

                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                "aria-labelledby": "basic-button",
                            }}
                        >
                            <MenuItem onClick={handleClose}>Profile</MenuItem>
                            {/* <MenuItem onClick={logoutHandel}>Logout</MenuItem> */}
                        </Menu>
                    </div>

                    <IconButton
                        className="reset"
                        sx={{ marginRight: ".2rem" }}
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <ImageController
                            src={
                                MAIN_USER?.image_path
                                    ? MAIN_USER?.image_path
                                    : UserImage
                            }
                            width="40px"
                            height="40px"
                            br="50%"
                            objectFit="cover"
                        />
                    </IconButton>
                    <IconButton
                        onClick={async () => {
                            await dispatch(logout());
                            await dispatch(reset());
                            navigate("/");
                        }}
                    >
                        <LogoutOutlined className="logout" />
                    </IconButton>
                </div>
                {composeBox && (
                    <MessagesCompose
                        closeCompose={handelComposeBox}
                    ></MessagesCompose>
                )}
            </TopNavStyle>
        </>
    );
};

const MessagesCount = styled.span`
    position: absolute;
    font-size: 0.7em;
    top: 0;
    right: 1px;
    background: red;
    color: #fff;
    font-weight: bold;
    border-radius: 50%;
    width: 15px;
    height: 15px;
`;
const Prand = styled.div`
    background: var(--main-color);
    padding: 1rem;
    border-radius: var(--border-radius);
    justify-content: space-between;
    svg {
        color: var(--white);
    }
`;

export default TopNavbar;
